import React, {useState, useContext, useCallback, useEffect} from 'react';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useValidation } from 'gw-portals-validation-react';
import { LocalDateUtil } from 'gw-portals-util-js';
import { ModalNextProvider } from '@jutro/components';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import { InputField, DateField, DropdownSelectField, Icon, Button} from '@jutro/components';
import { ViewModelServiceContext, withViewModelService } from 'gw-portals-viewmodel-react';
import metadata from './PolicyDetailsPage.metadata.json5';
import ContactComponent from 'gw-capability-policychange-ho-react/components/Contact/ContactComponent';
import messages from './PolicyDetailsPage.messages';
import { commonMessages } from 'gw-capability-quoteandbind-common-react';
import styles from 'gw-capability-policychange-ho-react/components/AdditionalInsuredInterest/AdditionalInsuredInterestComponent.module.scss'
import {CanceledPolicyComponent,AccountContactSearchComponent} from 'gw-capability-gateway-react';
import {AdditionalInsuredInterestComponent} from 'gw-capability-policychange-ho-react';
import { useAuthentication } from 'gw-digital-auth-react';
import PortalUtil from '../../../../utils/PortalUtil';
import _ from 'lodash';
import { UserService, OrganizationService } from 'gw-capability-gateway';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';


function PolicyDetailsPage(props) {
    const { initialValidation, isComponentValid, onValidate } = useValidation('PolicyDetailsPage');
    const { wizardData: submissionVM, updateWizardData, isNewSubmission } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const [editContactVM, setEditContactVM] = useState({});
    const [editContactIndex, setEditContactIndex] = useState(-1);
    const [accountContacts, setAccountContacts] = useState([{}]);
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const {dateUtil} = PortalUtil;
    const intl = useContext(IntlContext);
    const [producerCodeOrgValue, updateProducerCodeValue] = useState([]);


    useEffect(()=>{
        if(!submissionVM.baseData.account.aspects.valid || !submissionVM.baseData.account.aspects.subtreeValid){
            try{
                ModalNextProvider.showAlert({
                    title: 'Invalid Data',
                    message: 'Please review your account details and correct the issue',
                    status: 'error',
                    icon: 'mi-error-outline'
                })
            } catch(err){
                console.log(err);
            }
        }
        if(!_.get(submissionVM, 'baseData.termTypeAuto.value')){
            submissionVM.baseData.termType.value = 'Annual';
        }
        const _contacts = submissionVM.baseData.account.accountContacts.value.map((c) => {
            c['id'] = c.publicID;
            return c;
        });
        _contacts.push({ id: "placeholder", displayName: "Search Existing Contacts" });
        setAccountContacts(_contacts);
        const accProducerCodes = [] ;
        const producerCodesPromise = OrganizationService.getProducerCodeForOrganization(submissionVM.baseData.value.account.producerCodes[0].organizationDTO, authHeader);
        producerCodesPromise.then((producerCodesResponse) => {
            _.each(producerCodesResponse, (producerCodeValue) => {
                accProducerCodes.push({code : producerCodeValue.code,name :  producerCodeValue.displayValue});
            });
            updateProducerCodeValue(accProducerCodes);
        }, () => {
        });
        const drivers = submissionVM.lobData.businessAuto.coverables.drivers.children
        if(drivers.length > 0){
            _.each(drivers, (driver) => {
                driver.isValidationRequired.value = false;
                _.each(driver.licenseClassificationRecords.children, (licenseRecord) => {
                    licenseRecord.isValidationRequired.value = false;
                })
            })
        }
        _.each(submissionVM.baseData.priorLossHistoryRecords.children, (item) => {
            item.isAutoValidationRequired = false
        })
    }, [submissionVM])

    const createVM = (model) => {
        return viewModelService.create(
            model,
            'pc',
            'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO'
        );
    };

    const createAdditionalInsuredInterestVM = (model) => {
        return viewModelService.create(
            model,
            'pc',
            dtoPath
        );
    }


    const onInsuredChange = (value) => {
        const namedInsured = submissionVM.baseData.account.accountContacts.value.filter((c) => {
            return c.publicID == value;
        })[0];

        const additionalInsuredInterestContact = {
            accountPublicId: namedInsured.publicID,
            certificateRequired: false,
            type: "",
            policyAdditionalInsured: namedInsured
        };

        submissionVM.baseData.additionalNamedInsureds.value.push(additionalInsuredInterestContact);
        updateWizardData(submissionVM);
    } 

    const editAdditionalInsuredInterest = (index) => {
        setEditContactIndex(index);
        const _contactVM = _.get(submissionVM, `baseData.additionalNamedInsureds.children.${index}.policyAdditionalInsured.value`);
        _contactVM.isFromPortal = true;
        _contactVM.primaryAddress.isFromPortal = true;
        setEditContactVM(createVM(_contactVM));
    }

    const deleteAdditionalInsuredInterest = (index) => {
        submissionVM.baseData.additionalNamedInsureds.value.splice(index, 1);
        updateWizardData(submissionVM);
    }

    const onSaveEditContact = (index) => {
        var _editContactVM = viewModelService.clone(editContactVM);
        _.set(submissionVM, `baseData.additionalNamedInsureds.children.${index}.policyAdditionalInsured.value`, _editContactVM.value);
        setEditContactVM({});
        setEditContactIndex(-1);
    }

    const onCancelEditContact = () => {
        setEditContactVM({});
        setEditContactIndex(-1);
    }

    const onEditValueChange = (value, path, index) => {
        var _editContactVM = viewModelService.clone(editContactVM);
        _.set(_editContactVM, path, value);
        _.set(submissionVM, `baseData.additionalNamedInsureds.children.${index}.policyAdditionalInsured.value`, _editContactVM.value);
        setEditContactVM(_editContactVM);
    }

    const generateOverrides = () => {

        const overrides = submissionVM.baseData.additionalNamedInsureds.children.map((item, index) => {
            return {
                [`additionalNamedInsuredInterestName${index}`]: {
                    path: `baseData.additionalNamedInsureds.children.${index}.policyAdditionalInsured.displayName`
                },
                [`additionalInsuredInterestTitle${index}`]: {
                    content: `${translator(messages.additionalNamedInsured)}: ${index + 1}`
                },
                [`editAdditionalInsuredInterest${index}`]: {
                    onClick: (e) => {  editAdditionalInsuredInterest(index) },
                    disabled: Object.keys(editContactVM).length > 0
                },
                [`deleteAdditionalInsuredInterest${index}`]: {
                    onClick: (e) => { deleteAdditionalInsuredInterest(index) },
                    disabled: Object.keys(editContactVM).length > 0
                },
                [`editContact${index}`]: {
                    contactVM: editContactVM,
                    onValueChange: (value, path) => { onEditValueChange(value, path, index) },
                    visible: editContactIndex === index
                },
                [`saveEditContact${index}`]: {
                    onClick: () => { onSaveEditContact(index) },
                    visible: editContactIndex === index,
                    disabled: editContactVM.aspects ? (!editContactVM.aspects.valid
                        || !editContactVM.aspects.subtreeValid) : false
                },
                [`cancelEditContact${index}`]: {
                    onClick: onCancelEditContact,
                    visible: editContactIndex === index
                }
            }
        })
        return Object.assign({}, ...overrides);
    }

    // const addCancellationData = () => {
    //     submissionVM.baseData.priorCancelledRecords.value = submissionVM.baseData.priorCancelledRecords.value || [];
    //     submissionVM.baseData.priorCancelledRecords.value.push({
    //         cancelledDate: {},
    //         cancelledReason: "",
    //         cancelledPolicyNumber: "",
    //         isValidationRequired: true
    //     });
    //     updateWizardData(submissionVM);
    // }
/*
    const handleValueChange =  useCallback(
        (value, changedPath) => {
             _.set(submissionVM, changedPath, value);
             const newSubmissionVMClone = viewModelService.clone(submissionVM);
             updateWizardData(newSubmissionVMClone);
        },
        [submissionVM, updateWizardData]
    );
   
    const getTableCell =  useCallback(
        (item, index, props) => {   
            let path = props.path;
            const value = item[path];
            const itemPath = `baseData.priorCancelledRecords.value[${index}].${path}`;
            if (props.path == 'cancelledPolicyNumber') {
                return (
                    <InputField
                        id={index + path }
                        onValueChange={handleValueChange}
                        dataType="string"
                        path={itemPath}
                        value={value.value}
                    />
                );
            }
            else if (props.path == 'cancelledReason') {
                const availableValues = submissionVM.baseData.priorCancelledRecords.children.length > 0 ? submissionVM.baseData.priorCancelledRecords.children[0].cancelledReason.aspects.availableValues.map((typeCode) => {
                   return {
                           code: typeCode.code,
                           name: translator({
                               id: typeCode.name,
                               defaultMessage: typeCode.name
                           })
                       };
                   }): [];
                return (
                    <DropdownSelectField
                        id={index + path }
                        onValueChange={handleValueChange}
                        dataType="string"
                        path={itemPath}
                        value={value.value}
                        availableValues={availableValues}
                    />
                );
            }
            else if(props.path == 'cancelledDate') {
                return (
                    <DateField
                        id={index + path}
                        value={value.value}
                        dataType={_.isString(value.value) ? 'string' : 'object'}
                        path={itemPath}
                        format="short"
                        layout="full-width"
                        showOptional={false}
                        onValueChange={handleValueChange}
                    />
                );
            }
        },
        [submissionVM, handleValueChange]
    );*/

    const hasNoVehicle = () => {
        let noVehicleExist = false;
        if(submissionVM.lobData.businessAuto.coverables.vehicles && submissionVM.lobData.businessAuto.coverables.vehicles.length <= 0){
            noVehicleExist = true;
        }
        return noVehicleExist;
    }

    const hasPPVvehicle = () => {
        let ppvVehicleExist = false;
        if(submissionVM.lobData.businessAuto.coverables.vehicles && submissionVM.lobData.businessAuto.coverables.vehicles.length <=0){
            ppvVehicleExist = false;
        }
        else if(submissionVM.baseData.productCode.value == "BusinessAuto" && !_.isEmpty(submissionVM.lobData.businessAuto.coverables.vehicles)){
            ppvVehicleExist = submissionVM.lobData.businessAuto.coverables.vehicles.value.filter((v)=>{
                return v.vehicleType == "PrivatePassenger_EY"
             }).length ?   true :  false
        }
        return ppvVehicleExist
    }

    const hasIRCAvehicle = () => {
        let ircaVehicleExist = false;
        if(submissionVM.lobData.businessAuto.coverables.vehicles && submissionVM.lobData.businessAuto.coverables.vehicles.length <=0){
            ircaVehicleExist = false;
        }
        else if(submissionVM.baseData.productCode.value == "BusinessAuto" &&
            submissionVM.baseData.isARFCoverableEffectiveApr2026.value !== undefined && submissionVM.baseData.isARFCoverableEffectiveApr2026.value &&
             !_.isEmpty(submissionVM.lobData.businessAuto.coverables.vehicles)){
            ircaVehicleExist = submissionVM.lobData.businessAuto.coverables.vehicles.value.filter((v)=>{
                return (v.vehicleType == "CommercialVehTrailer_EY" || v.vehicleType == "FarmBuses_EY" || v.vehicleType == "FuneralDirectors" || v.vehicleType == "Commercial")
             }).length ?   true :  false
        }
        return ircaVehicleExist
    }


    const getPaymentFrequencyData = (paymentPlanData) => {
        if (paymentPlanData) {
            const paymentFrequencyOptionsArray = paymentPlanData.map((key) => {
                return {
                    name: key.name,
                    code: key.billingId
                };
            });
            return paymentFrequencyOptionsArray;
        }
        return [];
    };

    const updatePackage = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        // _.set(newSubmissionVM, `lobData.homeowners.allCoverables.children.${index}.value`, value);
        //_.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(newSubmissionVM);
    }

    const writeValue = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            if(path == 'baseData.termTypeAuto' || path == 'baseData.periodStartDate'){
                const term = _.get(submissionVM, 'baseData.termTypeAuto.value');
                const startDate = _.get(submissionVM, 'baseData.periodStartDate.value');
                let endDate = null
                if(term.code == "HalfYear"){
                    endDate = new Date(new Date(startDate.year, startDate.month, startDate.day).setMonth(new Date(startDate.year, startDate.month, startDate.day).getMonth() + 6))
                }
                else {
                    endDate = new Date(new Date(startDate.year, startDate.month, startDate.day).setMonth(new Date(startDate.year, startDate.month, startDate.day).getMonth() + 12))
                }
                endDate = {year: endDate.getFullYear(), month: endDate.getMonth(), day: endDate.getDate()}
                _.set(submissionVM, 'baseData.periodEndDate', endDate)
            }
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const insureds = submissionVM.baseData.additionalNamedInsureds.value.map((c) => { return c.accountPublicId });

    const onNext = useCallback(async () => {
        const startDate = dateUtil.toDate(_.get(submissionVM, 'baseData.periodStartDate.value'));
        const minDate = dateUtil.toDate(dateUtil.addDaysToLocalDate(LocalDateUtil.today(), -30));
        // if(minDate > startDate){
        //     try{
        //         await ModalNextProvider.showAlert({
        //             title: commonMessages.error,
        //             message: `${translator(messages.minimumDateError)} ${intl.formatDate(minDate, { year: 'numeric', month: 'short', day: 'numeric' })}`,
        //             status: 'error',
        //             icon: 'mi-error-outline'
        //         })
        //     } catch(err){
        //         console.log(err);
        //     }
        //     return false;
        // }
        if(!submissionVM.baseData.hasAnyCancel.value){
            submissionVM.baseData.priorCancelledRecords.value = []
        }
        _.unset(submissionVM.value, 'bindData');
        if(submissionVM.value.lobData && submissionVM.value.lobData.businessAuto && submissionVM.value.lobData.businessAuto.coverables &&
        submissionVM.value.lobData.businessAuto.coverables.drivers && submissionVM.value.lobData.businessAuto.coverables.drivers.length > 0){
            var primaryDriver = _.find(submissionVM.value.lobData.businessAuto.coverables.drivers, {
                sameAsAccountHolder: true
            });
            if(primaryDriver){
                primaryDriver.priorCancelledRecords = submissionVM.value.baseData.priorCancelledRecords;
            }
        }
        submissionVM.value = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );
        return submissionVM;
    }, [submissionVM]);

    const handlePriorCancelHistoryChange = (value) => {
        _.set(submissionVM, 'baseData.hasAnyCancel', value);
        submissionVM.baseData.priorCancelledRecords.value = []
        updateWizardData(submissionVM);
    }

    const updateAdditionalInsured = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, `baseData.additionalNamedInsureds.children.${index}.value`, value);
       // _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(newSubmissionVM);
    }

    const writeAdditionalInsuredValue = useCallback(
        (value, path) => {
            _.set(submissionVM, `baseData.${path}`, value);
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const startDate = dateUtil.toDate(_.get(submissionVM, 'baseData.periodStartDate.value'));
    const minDate = dateUtil.toDate(dateUtil.addDaysToLocalDate(LocalDateUtil.today(), -30));
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showOptional: false,
            showRequired: true
        },
        coverageStartDate: {
            //minDate: dateUtil.addDaysToLocalDate(LocalDateUtil.today(), -15),
            onValueChange: writeValue,
            //showErrors: minDate > startDate,
            //validationMessages: minDate > startDate ? [`${translator(messages.minimumDateError)} ${intl.formatDate(minDate, { year: 'numeric', month: 'short', day: 'numeric' })}`] : []
        },
        termType:{
            onValueChange: writeValue
        },
        additionalInsuredInterestContainer:{
            path: 'baseData.additionalNamedInsureds.children'
        },
        additionalInsuredTitle:{
            content: submissionVM.baseData.additionalNamedInsureds.length == 0 ? translator(messages.additionalNamedInsureds) : translator(messages.addAnotherAdditionNamesInsured)
        },
        additionalInsured: {
            coverableVM: submissionVM.baseData,
            accountContacts: accountContacts,
            accountNumber: submissionVM.baseData.accountNumber.value,
            type: 'additionalInsured',
            updatePackage: updateAdditionalInsured,
            authHeader: authHeader,
            onValueChange: writeAdditionalInsuredValue,
            isSubmission: true,
            jobID: submissionVM.quoteID.value,
            updateAccountContacts: setAccountContacts,
            availableValues: submissionVM.baseData.account.accountContacts.value.filter( (c) => {
                return insureds.indexOf(c.publicID) == -1
            } ).map( (c) => {
                c['id'] = c.publicID;
                return c;
            }),
        },
        addressDetails: {
            value: submissionVM.baseData.accountHolder.primaryAddress.displayName.value.split(', ').join('\n')
        },

        accountContactSearchId: {
            submissionVM: submissionVM,
            accountContacts: submissionVM.baseData.account.accountContacts,
            accountNumber: submissionVM.baseData.accountNumber,
            updatePackage: updatePackage,
            authHeader: authHeader,
            onValueChange: writeValue,
            updateWizardData:updateWizardData
        },


        // priorCancelationDataTable:{
        //     data: submissionVM.baseData.priorCancelledRecords.children
        // },
        // addCancelData:{
        //     onClick: addCancellationData
        // },

        cancelledByInsuranceCompany:{
            onValueChange: handlePriorCancelHistoryChange
        },

        canceledPolicycomponentID: {
            submissionVM : submissionVM,
            updateWizardData: updateWizardData,
            visible : submissionVM.baseData.hasAnyCancel.value == true,
            onValidate: onValidate
        },
        submissionProducerCode: {
            availableValues: producerCodeOrgValue
        },
        paymentFrequencyDropdownSelect: {
            visible: ( hasNoVehicle() || hasPPVvehicle() || hasIRCAvehicle() ) && submissionVM.baseData.paymentPlanData !== undefined,
            availableValues: submissionVM.baseData.paymentPlanData !== undefined ? getPaymentFrequencyData(submissionVM.baseData.paymentPlanData.value) : [],
            value : submissionVM.baseData.selectedPaymentPlanData ? submissionVM.baseData.selectedPaymentPlanData.value : null,
            required: ( hasNoVehicle() || hasPPVvehicle() || hasIRCAvehicle() ) && submissionVM.baseData.paymentPlanData !== undefined,
            onValueChange: writeValue
        },
        ...generateOverrides()
    };

    const removeAssignmentItem = (index) => {
        submissionVM.baseData.priorCancelledRecords.value.splice(index, 1);
        updateWizardData(submissionVM);
    }

    const removeAssignmentRow = useCallback(
        (item, index) => {
            return (
                <Button onClick={(e) => removeAssignmentItem(index, item)}>
                    <Icon icon="mi-delete" />
                </Button>
            );
        },
        [removeAssignmentItem]
    );


    

    const skipIntialValidation = async () => {
        const isValid = await initialValidation();
        return isValid && !isNewSubmission && submissionVM.aspects.valid && submissionVM.aspects.subtreeValid;
    }

    const resolvers = {
        resolveComponentMap: {
            contactComponent: ContactComponent,
            canceledpolicycomponent: CanceledPolicyComponent,
            accountContactSearch: AccountContactSearchComponent,
            additionalInsuredInterestComponent: AdditionalInsuredInterestComponent
        },
        resolveCallbackMap:{
            // getTableCell: getTableCell,
            removeAssignmentTableRow: removeAssignmentRow
        }
    };

    return (
        <WizardPage
            showPrevious={false}
            skipWhen={skipIntialValidation}
            disableNext={!isComponentValid || !submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid}
            onNext={onNext}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

PolicyDetailsPage.propTypes = wizardProps;
export default PolicyDetailsPage;
